import React, { useEffect } from 'react';
import AppRoutes from './routes/AppRoutes';
import './i18n';
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
      easing: 'ease-in-out',
    });
  }, []);

  return <AppRoutes />;
}

export default App;
